var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFlipUp = function SvgFlipUp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "#677F89",
    fill: "#677F89",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5L1 17H16V5L1 5Z",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5171 8H18.4828C18.3046 8 18.2154 8.2154 18.3414 8.3414L20.8586 10.8586C20.9367 10.9367 21.0633 10.9367 21.1414 10.8586L23.6585 8.3414C23.7845 8.2154 23.6953 8 23.5171 8Z",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1C16.4477 1 16 1.4477 16 2C16 2.5523 16.4477 3 17 3V1ZM17 3H19V1H17V3ZM20 4V8H22V4H20ZM19 3C19.5523 3 20 3.4477 20 4H22C22 2.3431 20.6568 1 19 1V3Z",
    stroke: "none"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFlipUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "fc923e126b8b12bb622cdb2b3580443f.svg";